"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoiceSharingState = void 0;
exports.VoiceSharingState = {
    Enabled: "enabled",
    Disabled: "disabled",
    Copied: "copied",
    CopiedDisabled: "copied_disabled",
};
